export class FeatureCompatibility {

  static YES     = new FeatureCompatibility('YES', true);
  static NO      = new FeatureCompatibility('NO', false);
  static UNKNOWN = new FeatureCompatibility('UNKNOWN', false);

  static fromBoolean(value: boolean): FeatureCompatibility {
    if (null == value) {
      return this.UNKNOWN;
    } else if (value) {
      return this.YES;
    }
    return this.NO;
  }

  static fromValue(value: string): FeatureCompatibility {
    for (const featureCompatibility of this.values()) {
      if (featureCompatibility.value === value) {
        return featureCompatibility;
      }
    }

    return this.UNKNOWN;
  }

  static values(): FeatureCompatibility[] {
    return Object.getOwnPropertyNames(this)
      .map(p => Object.getOwnPropertyDescriptor(this, p))
      .filter(p => p.enumerable)
      .filter(p => p.value instanceof FeatureCompatibility)
      .map(p => p.value);
  }

  private constructor(public value: string, public compatible: boolean) {
  }

  toBoolean(): boolean {
    return this.compatible;
  }
}

